import { render, staticRenderFns } from "./ImageEnlarge.vue?vue&type=template&id=1f2a7c4f&scoped=true"
import script from "./ImageEnlarge.vue?vue&type=script&lang=js"
export * from "./ImageEnlarge.vue?vue&type=script&lang=js"
import style0 from "./ImageEnlarge.vue?vue&type=style&index=0&id=1f2a7c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a7c4f",
  null
  
)

export default component.exports